import Honeybadger from 'honeybadger-js';

let instance = null;

class ErrorHandler {
  constructor() {
    if (!instance) {
      instance = this;
    }
    return instance;
  }

  configure(handleErrorCallback) {
    Honeybadger.configure({
      api_key: process.env.REACT_APP_GLM_HB_CONFIG_API_KEY,
      environment: process.env.REACT_APP_GLM_HB_CONFIG_ENVIRONMENT,
      debug: process.env.REACT_APP_GLM_HB_CONFIG_DEBUG,
    });

    this.handleErrorCallback = handleErrorCallback;
  }

  notify({
    name,
    component,
    action,
    context,
    fingerprint,
    triggerHandleErrorCallback = true,
    message = 'Unexpected exception',
    messageType = 'default',
  }) {
    if (triggerHandleErrorCallback && this.handleErrorCallback) {
      this.handleErrorCallback(messageType);
    }

    Honeybadger.notify('Unexpected exception', {
      name,
      component,
      action,
      context,
      fingerprint,
      message,
    });
  }
}

export default new ErrorHandler();
